<template lang="pug">
    .z-textarea(v-bind:class="{'focus': focus, 'no-label' : ($props.label ? false : true), 'is-dirty': isDirty, 'has-value': (value || value === 0), 'has-error': error && error.length, 'disabled': $props.disabled, 'readonly': $props.readonly, 'inline': $props.inline, 'border': $props.border, 'no-margin': $props.noMargin }")
        .z-textarea-container
            label(v-if="$props.label" v-bind:for="$props.id" v-html="($props.label + (($props.required) ? '*' : '') + ($props.readonly ? ' (только для чтения)' : '') + ($props.loading ? ' (загрузка)' : ''))")
            textarea(
                v-model="val"
                ref="input"
                v-bind:placeholder="$props.placeholder"
                v-bind:type="$props.type"
                v-bind:id="$props.id"
                v-bind:name="$props.name"
                v-bind:required="$props.required"
                v-bind:disabled="$props.disabled"
                v-bind:readonly="$props.readonly"
                v-bind:autocomplete="$props.autocomplete"
                v-bind:minlength="$props.minlength"
                v-bind:maxlength="$props.maxlength"
                v-on:focus="onFocus"
                v-on:blur="onBlur"
                v-on:keyup="onKeyUp"
                v-on:keypress="onKeyPress"
                v-on:paste="onPaste"
            )
            .shadow-height(ref="shadow") {{val}}
        .progress-bar-container
            md-progress-bar.progress-bar(md-mode="indeterminate" v-show="$props.loading")
        slot
        span.z-error(v-if="error") {{error}}
</template>
<script>
    export default {
        name: 'z-textarea',
        props: {
            type: {
                type: String,
                default: 'text'
            },
            id: {
                type: String,
                default: 'z-textarea'
            },
            name: {
                type: String,
                default: 'z-textarea'
            },
            label: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            autocomplete: {
                type: String,
                default: 'On'
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                type: [String, Number],
                default: () => ''
            },
            mask: {
                type: [String, Object],
                default: undefined
            },
            minlength: {
                type: Number,
                default: 0
            },
            maxlength: {
                type: Number,
                default: 5000
            },
            selectOnFocus: {
                type: Boolean,
                default: false
            },
            inline: {
                type: Boolean,
                default: false
            },
            border: {
                type: Boolean,
                default: false
            },
            noMargin: {
                type: Boolean,
                default: false
            },
            dirty: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isDirty: false,
                focus: false,
                val: ''
            }
        },
        created() {
            if (this.$props.value) {
                this.val = this.$props.value;
                this.$nextTick(() => this.resize());
            }
        },
        watch: {
            'value'(value) {
                if (this.val != value) {
                    this.val = value;
                    this.$nextTick(() => this.resize());
                }
            },
            'val'(val) {
                this.$emit('input', val);
                this.$emit('change', val);
                this.$nextTick(() => this.resize());
            },
            '$props.dirty'(val) {
                if (val && this.isDirty !== val) this.emitDirty();
            }
        },
        computed: {},
        methods: {
            onFocus(e) {
                if (this.$props.selectOnFocus && e && e.target) e.target.select();
                this.focus = true;
                this.$emit('focus', e);
            },
            onBlur(e) {
                this.focus = false;
                this.$emit('blur', e);
            },
            onKeyUp(e) {
                this.$emit('keyup', e);
            },
            onKeyPress(e) {
                this.$emit('keypress', e);
                this.emitDirty();
            },
            onPaste(e) {
                this.$nextTick(() => {
                    this.$emit('paste', e);
                    this.emitDirty();
                });
            },
            emitDirty() {
                this.isDirty = true;
                this.$emit('update:dirty', this.isDirty);
            },
            resize() {
                if (!this.$refs || !this.$refs.input || !this.$refs.shadow || this.$props.type != 'text') return;
                this.$refs.input.style.height = '100px';
                let height = this.$refs.shadow.offsetHeight;
                if (height < 100) height = 100;
                this.$refs.input.style.height = height + 'px';
            }
        }
    }
</script>
<style lang="sass">
    .z-textarea
        margin: 4px 0 10px 0
        .progress-bar-container
            position: relative
            width: 100%
            .progress-bar
                position: absolute
                right: 0
                width: 100%
                background-color: transparent
                height: 2px
        .z-textarea-container
            position: relative
        .z-error
            display: block
            height: auto
            min-height: 15px
            font-size: 11px
            line-height: 11px
            padding: 8px 0 0
            color: #ff1744
        label
            display: block
            color: rgba(0, 0, 0, 0.54)
            font-size: 12px
            font-weight: 500
            line-height: 12px
            transition: .4s cubic-bezier(.25,.8,.25,1)
            transition-duration: .3s
            z-index: 5
            resize: none
            margin-bottom: 10px
            span
                color: #D66565
        textarea, input
            display: block
            line-height: 16px
            padding: 7px 10px
            border: none
            background: #F1F1F1
            outline: none
            color: #000
            font-weight: 400
            height: 100px
            width: 100%
            position: relative
            z-index: 10
            resize: none
            overflow: hidden
            font: normal 12px Roboto
        .shadow-height
            display: block
            visibility: hidden
            position: absolute
            z-index: -1
            opacity: 0
            font-size: 14px
            line-height: 16px
            font: normal 14px Roboto
            background: #b7d0d0
            padding: 6px 0
        .error
    .z-textarea.no-label
        .z-textarea-container
            padding: 0
    .z-textarea.has-error
        input, textarea
            background: rgba(214, 101, 101, 0.1)
            border: 1px solid #D66565
        label   
            color: #ff1744
        .z-textarea-container
            &::after
                background-color: #ff1744
            &::before
                background-color: #ff1744
    .z-textarea.focus
        label
            color:  #2196f3
    .z-textarea.disabled
        textarea
            background: #eaeaea
        input
            background: #eaeaea
    .z-textarea.readonly
        textarea
            background: #eaeaea
        input
            background: #eaeaea
    .z-textarea.inline
        .z-textarea-container
            display: flex
            align-items: center
        label
            width: 40%
            flex: 0 0 40%
            padding-right: 8px
            margin: 0
        .z-error
            width: 60%
            margin: 0 0 auto auto
        .progress-bar
            width: 60%
    .z-textarea.border
        input
            border: 1px solid #BEBEBE
    .z-textarea.no-margin
        margin: 0
    .z-textarea.is-dirty
        label
            color: #2196f3
</style>


// WEBPACK FOOTER //
// ZTextArea.vue?09137dbc